import { Component, OnInit, OnDestroy, AfterViewInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { trigger, transition, style, animate } from '@angular/animations';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DeviceService } from 'src/app/services/devices/device.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { WebsocketService } from 'src/app/services/websocket/websocket.service';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LoadingPopupComponent } from 'src/app/components/ui/loading-popup/loading-popup.component';
import { ErrorModalComponent } from 'src/app/components/ui/error-modal/error-modal.component';
import { ConnectorState } from 'src/assets/js/constants';
import { infoModulator } from 'src/app/models/Modulator/infoModulator';
import { Chart } from 'chart.js/auto';
import { PowerCircleComponent } from 'src/app/components/power-circle/power-circle.component';
import { EnergyFlowLineComponent } from 'src/app/components/energy-flow-line/energy-flow-line.component';
import Colors from 'src/assets/js/colors';
import { compare } from 'compare-versions';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-charger',
    // standalone: true,
    // imports: [
    //   CommonModule,
    //   FormsModule,
    //   TranslateModule
    // ],
    templateUrl: './charger.component.html',
    animations: [
        trigger('zoomIn', [
            transition(':enter', [
                style({ transform: 'scale(0)', opacity: 0 }),
                animate('300ms ease-in', style({ transform: 'scale(1)', opacity: 1 }))
            ]),
            transition(':leave', [
                animate('300ms ease-out', style({ transform: 'scale(0)', opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
export class ChargerComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('containerCircles') containerRef!: ElementRef;

  @Input() device: string = '';


  @Output() event = new EventEmitter();
  splMode: number;
  canvasPie: any;
  ctxPie: any;
  chartPie: any;
  chartPieInside: any;
  canvas: any;
  ctx: any;
  chart: any;
  canvasHeat: any;
  ctxHeat: any;
  chartHeat: any;
  type_device: string;
  maxPower: number;

  statesPermission = [2, 4, 5, 6, 7, 8, 14, 30];
  statesNoPermission = [1, 3, 31];

  user: string = '';
  // device: string = '';
  infoModulator: infoModulator;

  errors = {
    heatmap: false,
    consumptions: false,
    state: false
  }

  historicStart = new Date();
  historicEnd = new Date();
  dataAnalytics;
  dataHistoric: any = [];
  dataHeatmap;
  showModal = false;

  loading = true;
  loadingConsumptions = true;
  loadingHeatmap = true;

  expandBool = {
    state: false,
    analytics: false,
    historic: false,
  }

  connectors: any[] = [];
  connectorsState: any = {};
  allStates = ConnectorState;

  totalEvse = 0;
  totalHome = 0;

  loadingModal: NgbModalRef;
  errorModal: NgbModalRef;

  deviceConnected = false;
  lastReport = Date.now();
  dateDisplay = 'short';

  intervalRT: any;

  solarInfo: any;

  version7_2_0 = false;
  subscription: Subscription;

 circleSelected = 0

 reqmanInfo: any = [] = []

 circlePositions: any[] = [];
 connections

 flowLines: any[] = [];
 containerWidth : number;
 containerHeight : number;
 loadingCircle : boolean;

 electricityRate: any;
 price = 0.0;
 pwmValue: number = 0;
 limitScheduler = false;
 num_phases = 3;

limitIcon: string[] = [];
limitText: string[] = [];
rfidLimit: boolean[] = [];
rfidLimitText = '';
tempEvent: number[] = [];
plugLimit: number[] = [];
connCfg: number[] = [];
connState: any[] = [];
rfid: { enabled: boolean, rfid: boolean } = { enabled: false, rfid: false };

vehicleLimitStartTime: { [connectorName: string]: number } = {};

selectedLimitText: string;

coin: string = '€';

  constructor(
    private _device: DeviceService,
    private _aRoute: ActivatedRoute,
    private _router: Router,
    private _ws: WebsocketService,
    private _modal: ModalService,
    private _translate: TranslateService,
    private _utils: UtilsService) {
      this.newPieCircles();
      this.subscription = this._device.serial$.subscribe((data) => {
        //receiving the data from the Parent component(app) and setting it to name field.
        if (data != '') {
          var deviceInfo = this._device.getActiveDeviceInfo();
          if (deviceInfo)
            this.version7_2_0 = compare(deviceInfo.firmware_version_name, '7.2.0', '>=');
        }
      });
  }

private resizeObserver: ResizeObserver;

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.containerRef?.nativeElement) {
        this.resizeObserver = new ResizeObserver(() => {
          const ancho = this.containerRef.nativeElement.offsetWidth;
          const alto = this.containerRef.nativeElement.offsetHeight;
          if (ancho !== this.containerWidth || alto !== this.containerHeight) {
            this.containerWidth = ancho;
            this.containerHeight = alto;
            this.newPieCircles();
          }
        });
        this.resizeObserver.observe(this.containerRef.nativeElement);
      }
    }, 800)
  }

  ngOnDestroy(): void {
    this.completeRT();
    if (this.resizeObserver && this.containerRef?.nativeElement) {
      this.resizeObserver.unobserve(this.containerRef.nativeElement);
    }
  }


  ngOnInit(): void {

    this.loadingCircle = true;
    this.connections = [
      { from: 'home', to: 'centro', invert: false },
      { from: 'car', to: 'centro', invert: false },
      { from: 'red', to: 'centro', invert: true },
      { from: 'solar', to: 'centro', invert: true },
      { from: 'battery', to: 'centro', invert: false },
    ];

    this._router.events.subscribe((val) => {
      if ((val instanceof NavigationEnd) && (this.device != this._aRoute.snapshot.params.serial)) {
        this.completeRT();
        this.totalHome = 0;
        this.totalEvse = 0;
        this.infoModulator = new infoModulator();
        this.loading = true;
        this.loadingHeatmap = true;
        this.loadingConsumptions = true;
        this.errors.state = false;
        this.errors.consumptions = false;
        this.errors.heatmap = false;
        this.deviceConnected = false;

        // Limpiar límites del dispositivo anterior para que el icono no quede desfasado
        this.limitIcon = [];
        this.limitText = [];
        this.rfidLimit = [];
        this.tempEvent = [];
        this.plugLimit = [];
        this.connCfg = [];
        this.connState = [];
        this.rfid = { enabled: false, rfid: false };
        this.limitScheduler = false;

        this.device = this._aRoute.snapshot.params.serial;
        this.loadingCircle = true;
        this.loadData();
        this.connectWS();
        this.isOnline();
      }
    });

    var time = this._device.isFirstLoad ? 1000 : 500;

    this.infoModulator = new infoModulator();
    this.device = this._aRoute.snapshot.params.serial;
    this.isOnline();
    this.device.charAt(4) == '3' ?
      this.type_device = 'UNI' : this.type_device = 'COMBIPLUS';

    setTimeout(() => {
      this.loadData();
    }, time);
    this.connectWS();


  }

  connectWS() {
    this._ws.connect(this.device)
                    .subscribe(data => {
                      this.lastReport=Date.now();
                      switch (data.module) {
                        case "modulator_evse":
                        case "modulator":

                          if(this.infoModulator){
                            if (!data.element) {
                              Object.entries(data.data.stat).forEach(entry => {
                                this.infoModulator.stat[entry[0]] = entry[1];
                              })
                              this.infoModulator.stat.timestamp = new Date();
                              this.updateCircles();
                              if(data.data?.stat?.maxPower)
                                this.maxPower = data.data.stat.maxPower;
                            }
                            else{
                              this.connectorsState[data.element].current = Math.round(Math.max(...data.data.stat.current)/100)/10;
                              this.connectorsState[data.element].energy = Math.round((data.data.stat.active - data.data.stat.startActive)/10)/100;
                              this.connectorsState[data.element].pwm = Math.round(data.data.stat.assignment/100)/10;
                              this.connectorsState[data.element].power = Math.round((data.data.stat.aPow[0] + data.data.stat.aPow[1] + data.data.stat.aPow[2])/100)/10;
                            }
                            console.log("infoModulator: ", 'background: brown; color: white', data.data);
                          }
                          break;

                        case "evsm_evse":
                        case "evsm":
                          if(data.data.stat.state){
                            this.connectorsState[data.element].state=data.data.stat.state;
                            if(this.statesPermission.includes(data.data.stat.state))
                              this.connectorsState[data.element].permission=data.data.stat=true;
                            else if(this.statesNoPermission.includes(data.data.stat.state))
                              this.connectorsState[data.element].permission=false;
                            else
                              this.connectorsState[data.element].permission=-1;
                          }
                          console.log("%cconnectorsState: ", 'background: orange; color: white', this.connectorsState);
                          break;

                                      case "mennekes":
              // if (data.element) {
              //   var connector = this.connectors.find(conn => conn.name == data.element);
              //   connector.mennekes = data.data;
              // }

              break;
                      };
                      this.limits();

      },
        err => {
          //console.log(err);

          this._modal.showWarn(this._translate.instant("deviceDisconnectedFromServer"), this._translate.instant("connectionCouldNotBeStablished"));
          this.deviceConnected = false;
        },
        () => console.log('complete')
      )
  }


  startRT(context) {
    var data = {};
    if(this.device.startsWith('EVVC1')){
      data = {UPDATE: 1, TIMEOUT: 120};
    }
    else{
      data = { period: 1, timeout: 120, status: true };
    }

    context._device.setRT(this.device, data)
      .subscribe(data => {
        if (!this.deviceConnected)
          // this._modal.showSuccess(this._translate.instant("deviceConnectedToServer"), '');
        this.deviceConnected = true;
      }, (err) => {
        // if (this.deviceConnected || this.deviceConnected == undefined)
          // this._modal.showWarn(this._translate.instant("deviceDisconnectedFromServer"), this._translate.instant("connectionCouldNotBeStablished"));
      })
  }

  completeRT() {
    this._device.setRT(this.device, { period: 1, timeout: 120, status: false })
      .subscribe(data => {
      })

    clearInterval(this.intervalRT);
    this._ws.close();
  }

  loadData() {
    this.startRT(this);
    let context = this;
    this.intervalRT = setInterval(() => {
      this.startRT(context);
    }, 120000)

    this._device.getModuleInfo(this.device, "solar")
      .subscribe(data => {
        this.solarInfo = data;
        if (typeof this.solarInfo?.cfg?.inversor === "string")
          this.solarInfo.cfg.inversor = JSON.parse(this.solarInfo.cfg.inversor);
      })

    this._device.getElemDevice(this.device)
      .subscribe(data => {
        this.connectors = Array.isArray(data) ? data : [];
        this._device.getElementModule(this.device, "evsm")
          .subscribe(data => {
            data.forEach((conn, i) => {
              this.connectorsState[conn.name] = conn.data.stat;
              if (this.statesPermission.includes(conn.data.stat.state))
                this.connectorsState[conn.name].permission = conn.data.stat = true;
              else if (this.statesNoPermission.includes(conn.data.stat.state))
                this.connectorsState[conn.name].permission = conn.data.stat = false;
              else
                this.connectorsState[conn.name].permission = conn.data.stat = -1;

              this._device.getElementModule(this.device, 'schedman', conn.name)
                .subscribe(data => {
                  this.connState[i] = data.stat;
                  this.maxPower=data.cfg.tasks;
                    if(data.stat && (data.stat.state == 0 || data.stat.state == 4)){
                    this.limitScheduler = true;
                  }else{
                    this.limitScheduler = false;
                  }
                  this.limits();
                }, (err) => {

                })


                this._device.getElementModule(this.device, "mennekes").subscribe(data => {
                    this.pwmValue = data[0].data.stat.ampacitySmCh;
                      this.tempEvent[i] = data[i].data.stat.tempEvent;
                      this.plugLimit[i] = data[i].data.stat.plugLimit;
                      this.connCfg[i] = data[i].data.cfg.limitPower;
                  })


              if (this.version7_2_0) {
                this._device.getElementModule(this.device, 'sys', conn.name, 'boost', { localdata: true })
                  .subscribe(data => {
                    this.connectors[i].booster = data.boost < 0 ? false : true;
                    console.log(data);
                  })
              }
            });

            if (!data[1])
              this.connectors.splice(1, 1);
            console.log("%cconnectorsState: ", 'background: orange; color: white', this.connectorsState);
          })
      });


      this._device.getModuleInfo(this.device, 'rfid').subscribe((data) => {
        this.rfid.enabled = data.cfg.enabled;
        this.rfid.rfid = data.cfg.rfid;
        this.limits();
      })

    this._device.getHistoricGraphView(this.device,
      this._utils.getFormatedLocalDate(this.historicEnd, 'YYYY-MM-DD'),
      this._utils.getFormatedLocalDate(this.historicStart, 'YYYY-MM-DD'))
      .subscribe(data => {

        let filledData: any[] = [];
        for (let i = 0; i < 24; i++) {

          let findHour = data.data.find(d => Number.parseInt(this._utils.getFormatedLocalDate(d.hour, 'HH')) == i)
          findHour ? filledData.push(findHour) : filledData.push({});
        }
        this.dataAnalytics = filledData;
        console.log("%cHistorics: ", 'background: blue; color: white', this.dataAnalytics)
        this.loadingConsumptions = false;
        setTimeout(() => {
          try {
            this.loadGraphHistorics();
          } catch (error: any) {
            console.error("%cLoad Graph Historics: ", 'background: black; color: white;', error.message);
          }
        }, 300);
      }, err => {
        this.loadingConsumptions = false;
        this.errors.consumptions = true;
      });

    // this._device.getHeatmap(this.device)
    //   .subscribe(data => {
    //     this.dataHeatmap = data.data;
    //     this.loadingHeatmap = false;
    //     console.log("%cHeatmap: ", 'background: blue; color: white', this.dataHeatmap)
    //     setTimeout(() => {
    //       this.loadHeatmap();
    //     }, 300);
    //   }, err => {
    //     this.loadingHeatmap = false;
    //     this.errors.heatmap = true;
    //   });

    // this._device.getModuleInfo(this.device, 'evsm')
    //   .subscribe(data => {
    //     this.loading = false;
    //     console.log(data);
    //   })

          this._device.getElementModule(this.device, "reqman").subscribe(data => {
            this.reqmanInfo = data;
            console.log(Object.keys(this.reqmanInfo).length, "reqmanInfo: ", this.reqmanInfo);

          })


    this._device.getModuleInfo(this.device, 'modulator')
      .subscribe(data => {
        console.log("%cinfoModulator: ", 'background: brown; color: white', this.infoModulator);
        this.infoModulator.update(data);
        if (data.stat?.maxPower)
          this.maxPower = data.stat.maxPower;
        //console.log(data);
        this.loading = false;
        console.log("%cinfoModulator: ", 'background: brown; color: white', this.infoModulator);
        setTimeout(() => {
          try {
            this.newPieCircles()
            // this.loadGraphPie();
          } catch (error) {
            console.error("%cLoad Graph Pie: ", 'background: black; color: white;', error);
          }
        }, 300);
      }, (err) => {
        this.errors.state = true;
        this.loading = false;
      })



    this._device.getModuleInfo(this.device, 'sys')
      .subscribe(data => {
        console.log(data);
        this.num_phases = data.stat.fwv_pot.startsWith('3') ?( data.cfg.phase!=1 ? 3 : 1): 1;
      })
    this.dataHistoric = [];

    this._device.getHistorics(this.device).subscribe(data => {
      this.dataHistoric = data.historic;
    });
    this._device.getModuleInfo(this.device, "spl").subscribe((data) => {
      if (data.cfg) {
        this.splMode = data.cfg.splMode
        this.event.emit({ title: this.splMode });

        console.log(this.splMode);
      }

    });

    this._device.getElectricityRate(this.device).subscribe((data) => {
      this.electricityRate = data;
      if (this.electricityRate?.cfg && this.electricityRate.cfg.type == 'fixed') {
        this.price = this.electricityRate.cfg.periods[0].price;
      }
      this.coin = data.cfg.coin;
      if (this.coin == 'EUR') {
        this.coin = '€';
      } else if (this.coin == 'USD') {
        this.coin = '$';
      } else if (this.coin == 'GBP') {
        this.coin = '£';
      } else if (this.coin == 'COP') {
        this.coin = 'COP';
      }
    })
    setTimeout(() => {
      this.limits();
    }, 1000);
  }


  loadGraphHistorics() {
    var dataEvse = {
      label: 'Evse',
      data: [0],
      backgroundColor: [
        Colors.secondary
      ]
    };
    var dataHome = {
      label: 'Home',
      data: [0],
      backgroundColor: [
        Colors.primary
      ]
    };

    this.dataAnalytics.forEach((hour, index) => {
      let evsePower = hour.elements?.reduce((acc, element) => { return acc +  Number.parseInt(element.active)}, 0);

      if (index == 0) {
        dataEvse.data[0] = (evsePower);
        dataHome.data[0] = (parseInt(hour.homeEnergy));
      } else {
        dataEvse.data.push(evsePower);
        dataEvse.backgroundColor.push(Colors.secondary);
        dataHome.backgroundColor.push(Colors.primary);
        dataHome.data.push(parseInt(hour.homeEnergy));
      }

      this.totalEvse += evsePower;
      this.totalHome += hour.homeEnergy;
    });


    var labels = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"];
    this.canvas = document.getElementById("chart");
    this.ctx = this.canvas.getContext("2d");
    this.chart = new Chart(this.ctx, {
      type: 'bar',
      data: {
        labels,
        datasets: [dataEvse, dataHome]
      },
      options: {
        scales: {
          y: {
            stacked: true,
            beginAtZero: true
          },
          x: {
            stacked: true,
            beginAtZero: true
          }
        },
        plugins: {
          legend: {
            display: true
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const label = context.dataset.label || '';
                const value = context.parsed.y;
                if (label === 'Evse') {
                  if (this.price > 0) {
                    const cost = value / 1000 * this.price;
                    return `${label}: ${value} Wh - Coste: ${cost.toFixed(2)} ${this.coin}`;
                  } else {
                    return `${label}: ${value} Wh`;
                  }
                } else {
                  return `${label}: ${value} Wh`;
                }
              }
            }
          }
        }
      },
    });

  }

  expand(type) {
    switch (type) {
      case 'state':
        this.expandBool.state = true;
        break;
      case 'analytics':
        this.expandBool.analytics = true;
        break;
      case 'historic':
        this.expandBool.historic = true;
        break;
    }
    this.showModal = true;

    // Actualizado para ng-bootstrap 17
    const modalElement = document.getElementById('button-modal-activate');
    if (modalElement) {
      // Usar ng-bootstrap 17 modal API
      if (typeof (window as any).bootstrap !== 'undefined') {
        const modal = new (window as any).bootstrap.Modal(document.getElementById('centeredModalPrimary'));
        modal.show();
      } else {
        // Fallback para el método anterior
        modalElement.click();
      }
    }
  }

  resetModals() {
    this.showModal = false;
    this.expandBool.state = false;
    this.expandBool.analytics = false;
    this.expandBool.historic = false;
  }

  getTranslatedText(key: string): string {
    // Validar que la clave no sea vacía o undefined
    if (!key || key.trim() === '') {
      //console.warn('Translation key is empty or undefined', key);
      return '';
    }

    try {
      return this._translate.instant(key);
    } catch (error) {
      console.error('Error translating key:', key, error);
      return key; // Retornar la clave original si hay error
    }
  }

  // isBoosterActivable(state){
  //   if(state >= 5 && state <= 7)
  //     return true;
  //   else
  //     return false;
  // }

  subtractDates(date1: Date | string, date2: Date | string): string {
    try {
      const d1 = typeof date1 === 'string' ? new Date(date1) : date1;
      const d2 = typeof date2 === 'string' ? new Date(date2) : date2;

      // Validar que las fechas sean válidas
      if (isNaN(d1.getTime()) || isNaN(d2.getTime())) {
        return 'N/A';
      }

      const diffMs = Math.abs(d1.getTime() - d2.getTime());

      // Calcular diferentes unidades
      const seconds = Math.floor(diffMs / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);

      // Retornar el formato más apropiado
      if (days > 0) {
        return `${days}d ${hours % 24}h ${minutes % 60}m`;
      } else if (hours > 0) {
        return `${hours}h ${minutes % 60}m`;
      } else if (minutes > 0) {
        return `${minutes}m ${seconds % 60}s`;
      } else {
        return `${seconds}s`;
      }
    } catch (error) {
      console.error('Error calculating date difference:', error);
      return 'N/A';
    }
  }


  changeStateConnector(name) {
    this.loadingModal = this._modal.open(LoadingPopupComponent);
    var body = {
      uid: 1,
      source: "app",
      priority: 0,
      action: this.connectorsState[name].permission ? 1 : 0,
      user: "",
      group: 0
    }
    this._device.updateModuleElement(this.device, "reqman", body, name).subscribe(data => {
      this.loadingModal.close();
    }, err => {
      this.loadingModal.close();
      this.errorModal = this._modal.open(ErrorModalComponent);
      this.errorModal.componentInstance.description = this._translate.instant("operation_error");
      this.connectorsState[name].permission = !this.connectorsState[name].permission;
    })
  }



  // subtractDates(date1, date2) {
  //   var difference_ms = new Date(date1).getTime() - new Date(date2).getTime();
  //   //take out milliseconds
  //   difference_ms = difference_ms / 1000;
  //   var seconds = Math.floor(difference_ms % 60);
  //   difference_ms = difference_ms / 60;
  //   var minutes = Math.floor(difference_ms % 60);
  //   difference_ms = difference_ms / 60;
  //   var hours = Math.floor(difference_ms % 24);
  //   if (hours != 0)
  //     return hours + 'h ' + minutes.toString() + 'm ' + seconds.toString() + 's';
  //   else return minutes.toString() + 'm ' + seconds.toString() + 's';
  // }

  // getTranslatedText(translationKey: string) {
  //   if(translationKey)
  //     return this._translate.instant(translationKey);
  //   else
  //     return null;
  // }

  setBoost(active, name){
    if(this.infoModulator?.stat){
      this.loadingModal=this._modal.open(LoadingPopupComponent);
      var body = {
        value: active?this.infoModulator.stat.limitPower:-1
      }
      this._device.updateModuleElement(this.device, "sys", body, name, "boost").subscribe( data => {
        this.loadingModal.close();
        this.connectors.find(conn => conn.name==name).booster=active;
      }, err=>{
        this.loadingModal.close();
        this.errorModal = this._modal.open(ErrorModalComponent);
        this.errorModal.componentInstance.description = this._translate.instant("operation_error");
      })
    }
  }

  isBoosterActivable(state){
    if(state >= 5 && state <= 7)
      return true;
    else
      return false;
  }

  getSolarIcon() {
    if (this.solarInfo?.cfg?.enabled) {
      if (this.reqmanInfo[0]?.data?.stat?.priority != 1 && this.infoModulator?.stat?.maxPower == 0) {
        return 'solar-panel';
      }
      else {
        return 'eco';
      }
    } else {
      return 'sin solar';
    }
  }


  newPieCircles() {
    if (!this.containerWidth || !this.containerHeight) return;

    const batteryEnabled = this.solarInfo?.cfg?.battery;
    const solarEnabled = this.solarInfo?.cfg?.enabled;

    if (batteryEnabled) {
      this.circlePositions = [
        { x: this.containerWidth / 2,       y: this.containerHeight / 2 + 20,  radius: 30, colorScale: '#C4EBE9',         title: 'centro',  value: 0, icon: this.getSolarIcon(), },
        { x: this.containerWidth / 2 - 140, y: this.containerHeight / 2 - 40,  radius: 52, colorScale: '#ea4c88',         title: 'battery', value: this.infoModulator?.stat.battEnergy, invert: false },
        { x: this.containerWidth / 2 + 140, y: this.containerHeight / 2 - 40,  radius: 52, colorScale: Colors.yellow,     title: 'solar',   value: this.infoModulator?.stat.fvPower,    invert: false },
        { x: this.containerWidth / 2 + 100,  y: this.containerHeight / 2 + 95,  radius: 52, colorScale: Colors.accent_blue,     title: 'car',     value: this.infoModulator?.stat.evsePower,  invert: true },
        { x: this.containerWidth / 2 - 100,  y: this.containerHeight / 2 + 95,  radius: 52, colorScale: Colors.secondary,  title: 'home',    value: this.infoModulator?.stat.homePower,  invert: true },
        { x: this.containerWidth / 2,       y: this.containerHeight / 2 - 105,  radius: 52, colorScale: Colors.primary,    title: 'red',     value: this.infoModulator?.stat.instPower,  invert: false }
      ];
    } else if (solarEnabled) {
      this.circlePositions = [
        { x: this.containerWidth / 2,       y: this.containerHeight / 2,      radius: 30, colorScale: '#C4EBE9',        title: 'centro',  value: 0, icon: this.getSolarIcon() },
        { x: this.containerWidth / 2 - 100,  y: this.containerHeight / 2 + 85, radius: 52, colorScale: Colors.secondary, title: 'home',    value: this.infoModulator?.stat.homePower,  invert: true },
        { x: this.containerWidth / 2 + 100,  y: this.containerHeight / 2 + 85, radius: 52, colorScale: Colors.accent_blue,    title: 'car',     value: this.infoModulator?.stat.evsePower,  invert: true },
        { x: this.containerWidth / 2 + 120, y: this.containerHeight / 2 - 85, radius: 52, colorScale: Colors.yellow,    title: 'solar',   value: this.infoModulator?.stat.fvPower,    invert: false },
        { x: this.containerWidth / 2 - 120, y: this.containerHeight / 2 - 85, radius: 52, colorScale: Colors.primary,   title: 'red',     value: this.infoModulator?.stat.instPower,  invert: false }
      ];
    } else {
      this.circlePositions = [
        { x: this.containerWidth / 2 ,       y: this.containerHeight / 2 + 20,      radius: 30, colorScale: '#C4EBE9',        title: 'centro',  value: 0, icon: this.getSolarIcon() },
        { x: this.containerWidth / 2 - 100,  y: this.containerHeight / 2 + 95, radius: 52, colorScale: Colors.secondary, title: 'home',    value: this.infoModulator?.stat.homePower,  invert: true },
        { x: this.containerWidth / 2 + 100,  y: this.containerHeight / 2 + 95, radius: 52, colorScale: Colors.accent_blue,    title: 'car',     value: this.infoModulator?.stat.evsePower,  invert: true },
        { x: this.containerWidth / 2,       y: this.containerHeight / 2 - 100,radius: 52, colorScale: Colors.primary,   title: 'red',     value: this.infoModulator?.stat.totalPower, invert: false }
      ];
    }


    this.flowLines = this.circlePositions

      .filter(circle => circle.title !== 'centro')
      .map(circle => {
        const centro = this.circlePositions.find(c => c.title === 'centro');
        const from = circle;
        const to = centro ?? { x: 160, y: 165 };
        const value = circle.value ?? 0;

        let invert = false;
        if (circle.title === 'red') {
          invert = this.infoModulator?.stat?.instPower < 0
        } else if (circle.title === 'battery') {
          invert = this.infoModulator?.stat?.battEnergy < 0;
        } else if (circle.title === 'solar') {
          invert = false;
        } else {
          invert = true;
        }

        return {
          x1: from.x,
          y1: from.y,
          x2: to.x,
          y2: to.y,
          colorScale: circle.colorScale,
          invert,
          animated: value !== 0
        };
      });
    setTimeout(() => {
      this.loadingCircle = false
    }, 400);

  }

  updateCircles() {
    this.circlePositions = this.circlePositions.map(c => {
      const valueMap = {
        home: this.infoModulator?.stat.homePower,
        car: this.infoModulator?.stat.evsePower,
        red: this.solarInfo?.cfg?.enabled ? this.infoModulator?.stat.instPower : this.infoModulator?.stat.totalPower,
        centro: 150,
        solar: this.infoModulator?.stat.fvPower,
        battery: this.infoModulator?.stat.battEnergy,
      };
      let updatedInvert = c.invert; // valor por defecto
      if (c.title === 'red') {
        updatedInvert = this.infoModulator?.stat?.instPower < 0;
      } else if (c.title === 'battery') {
        updatedInvert = this.infoModulator?.stat?.battEnergy < 0;
      }

      return {
        ...c,
        value: valueMap[c.title] ?? c.value,
        invert: updatedInvert
      };
    });

  this.flowLines = this.circlePositions
    .filter(c => c.title !== 'centro')
    .map(c => {
      const centro = this.getCircle('centro');
      const value = c.value ?? 0;
      return {
        x1: c.x,
        y1: c.y,
        x2: centro?.x ?? 0,
        y2: centro?.y ?? 0,
        colorScale: c.colorScale,
        invert: c.invert,
        animated: value !== 0
      };
    });
  }

  getCircle(title: string) {
    return this.circlePositions.find(c => c.title === title);
  }


  limits() {
    this.limitIcon = [];
    this.limitText = [];
    this.rfidLimit = [];
    this.tempEvent = [];

    for (let i = 0; i < this.connState.length; i++) {
      const connector = this.connectors[i];
      let vehicleAlertActive = false;

      // Verificar condición de limitación de vehículo y manejar timer
      const vehicleCondition = (this.connectorsState[connector.name]?.pwm - this.connectorsState[connector.name]?.current) > 1;
      if (vehicleCondition) {
        if (!this.vehicleLimitStartTime[connector.name]) {
          this.vehicleLimitStartTime[connector.name] = Date.now();
        }
        if (Date.now() - this.vehicleLimitStartTime[connector.name] >= 30000) {
          vehicleAlertActive = true;
        }
      } else {
        delete this.vehicleLimitStartTime[connector.name];
      }

        if (this.connState[i]?.state!= null && this.connState[i]?.state!= undefined) {
        const state = this.connState[i].state;
        const rfidOn = !!(this.rfid.enabled && this.rfid.rfid);
        this.rfidLimit.push(rfidOn);
        if (rfidOn) this.rfidLimitText = this._translate.instant("limitationReasonRfid");

        // El RFID es del cargador y se muestra aparte. En estado 0 o 3 no se sustituye por el de programación.
        if ((this.limitScheduler || state == 4 || state == 0) && !(rfidOn && (state == 0 || state == 3))) {
          this.limitIcon.push('schedule');
          this.limitText.push(this._translate.instant("limitationReasonScheduler"));

        } else if (this.tempEvent[i] == 1 || this.tempEvent[i] == 2) {
          this.limitIcon.push('thermostat');
          this.limitText.push(this._translate.instant("limitationReasonTemperature"));

        } else if (vehicleAlertActive) {
          this.limitIcon.push('directions_car');
          this.limitText.push(this._translate.instant("limitationReasonVehicle"));

        } else if (typeof this.plugLimit[i] === 'number' && this.plugLimit[i] < 32 && this.plugLimit[i] < (this.infoModulator.stat.limitPower / (this.num_phases === 3 ? 690 : 230))) {
          this.limitIcon.push('cable')
          this.limitText.push(this._translate.instant("limitationReasonCable") + ' ' + this.plugLimit[i] + 'A');

        } else if ((this.connectorsState[connector.name]?.pwm < 32) && (this.infoModulator.stat.limitPower - this.connectorsState[connector.name]?.pwm * (this.num_phases === 3 ? 690 : 230) / 1000 > 0)) {
          this.limitIcon.push('signal_cellular_2_bar');
          this.limitText.push(this._translate.instant("limitationReasonModulator"));

        } else {
          this.limitIcon.push('');
          this.limitText.push('');
          this.tempEvent[i] = 0;
        }
      }
    }

}

  limitsCfg(connector: any, numConnector: number): string {
    if (!connector?.name) return '';

    const cfg = this.connCfg?.[numConnector];
    const limitPower = this.infoModulator?.stat?.limitPower;
    if (typeof cfg !== 'number' || typeof limitPower !== 'number') return '';


    if (cfg < (this.num_phases === 3 ? 22080 : 7360) && cfg < limitPower) {
      return 'perm_data_setting';
    }
    return '';
  }

  limitsCfgText(connector: any, numConnector: number): string {
    const icon = this.limitsCfg(connector, numConnector);
    if (!icon) return '';

    const cfg = this.connCfg?.[numConnector];
    const denom = this.num_phases === 3 ? 690 : 230;
    const amps = typeof cfg === 'number' ? Math.round(cfg / denom) : undefined;
    const base = this._translate.instant('limitationReasonCfgConnector');

    return amps ? `${base} ${amps}A` : base;
  }


  isOnline(){
    this._device.isOnline(this.device).subscribe(data => {
      this._modal.showSuccess(this._translate.instant("deviceConnectedToServer"), '');
    }, err => {
      this._modal.showWarn(this._translate.instant("deviceDisconnectedFromServer"), this._translate.instant("connectionCouldNotBeStablished"));
      console.log(err);
    });
  }
}
